import React from 'react';
import { Button, Carousel, Container } from 'react-bootstrap';
import { BiLinkExternal } from 'react-icons/bi';
import Particle from '../../Particle';
import hotHome from "../../../Images/Project/hotonion/hotHome.JPG";
import hotBreakfast from "../../../Images/Project/hotonion/hotBreakfast.JPG";
import hotDinner from "../../../Images/Project/hotonion/hotDinner.JPG";
import hotlogin from "../../../Images/Project//hotonion/hotLogin.JPG";
const Hotonion = () => {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    Hot Onion <strong className="purple"> Website </strong>
                </h1>
                <div className='mt-5 mb-5'>
                    <div className='container '>
                        <div className='row '>
                            <div className='col-lg-6 col-sm-12'>
                                <Carousel fade>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={hotHome}
                                            alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={hotBreakfast}
                                            alt="Second slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={hotDinner}
                                            alt="Third slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={hotlogin}
                                            alt="fourth slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </div>
                            <div className='col-lg-6 col-sm-12'>
                                <p className='fw-bold text-white'>This is a Food Delivery and restaurant Website. Users can Choice the Food For Breakfast,Lunch and Dinner. </p>

                                <p className='text-white'>
                                    <ul>
                                        <li>Users can Login via Google sign, GitHub.</li>
                                        <li>Users can order food and give a review for each food and restaurant. (Works going on)</li>
                                        <li>Admin dashboard and user dashboard. (Working On it)</li>
                                        <li>Dynamic React Router Used in this Website user friendly website</li>
                                    </ul></p>
                                <p className='text-white'> Front-end technology: React js, Bootstrap, React Router</p>
                                <Button href='https://github.com/nhnajmul17/hot-onion' style={{ marginRight: '3px' }} className='btn btn-info '>  <BiLinkExternal /> &nbsp;Client Side</Button>

                                <Button href='hot-onion-01.web.app/' className='btn btn-info'>  <BiLinkExternal /> &nbsp;Live Site</Button>

                            </div>

                        </div>

                    </div>


                </div>


            </Container>
        </Container>
    );
};

export default Hotonion;